import React, { useState } from "react";
import styled from "@emotion/styled";

// Utils
import { PageGutter, Colors } from "../../../common/utils/constants";

// Components
import Typography from "../../../common/components/Typography";

// Mui
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

// Images
import Arrow from "@mui/icons-material/ChevronRightOutlined";

const Container = styled.section`
    padding: ${PageGutter};

    .MuiPaper-root {
        padding: 7px 20px;
        margin-bottom: 15px;
        border-radius: 7px;
        box-shadow: none;

        &:before {
            display: none;
        }
    }
`;
const RichTextBlock = styled.div`
    color: ${Colors.greyDark} !important;
    font-family: "Poppins", sans-serif !important;
`;

const FAQ = ({ questions }) => {
    const [expanded, setExpanded] = useState();

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <Container id="home-faq">
            <Typography variant="h4" pb={8}>
                Frequently Asked Questions
            </Typography>
            {questions &&
                questions.map((question, index) => (
                    <Accordion
                        key={index}
                        expanded={expanded === question.title}
                        onChange={handleChange(question.title)}
                    >
                        <AccordionSummary
                            expandIcon={
                                <Arrow
                                    sx={{
                                        fontSize: "1.8rem",
                                        color: Colors.accent,
                                    }}
                                />
                            }
                            aria-controls={question.title}
                            id={question.title}
                        >
                            <Typography
                                variant="h6"
                                sx={{ color: Colors.accent }}
                            >
                                {question.title}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <RichTextBlock
                                dangerouslySetInnerHTML={{
                                    __html: question.description,
                                }}
                            />
                        </AccordionDetails>
                    </Accordion>
                ))}
        </Container>
    );
};

export default FAQ;
